import React, { useEffect, useState } from 'react';
import { Container, Table, Button, Alert, Form, Tabs, Tab,Modal,Pagination} from 'react-bootstrap';
import { collection, query, where, getDocs,doc,updateDoc,getDoc,orderBy} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db,storage } from '../FireBase'; // Import Firestore
import { Link } from 'react-router-dom';
import ToastAlert from '../components/ToastAlert';
import { FaPrint ,FaNoteSticky, FaTruck  } from 'react-icons/fa6';
import { getStorage, ref, uploadBytes, getDownloadURL} from "firebase/storage";
import Loading from '../components/Loading';

const Delivery = () => {
    const [schemes, setSchemes] = useState([]);
    const [packedOrders, setPackedOrders] = useState([]);
    const [shippedOrders, setShippedOrders] = useState([]);
    const [searchQuery1, setSearchQuery1] = useState('');
    const [searchQuery2, setSearchQuery2] = useState('');
    const [searchQuery3, setSearchQuery3] = useState('');
    const [error, setError] = useState('');
    const [activeTab, setActiveTab] = useState('packed');
    const navigate = useNavigate();
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderNotes, setOrderNotes] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const [currentUser, setCurrentUser] = useState(null);
    const [trackingLink, setTrackingLink] = useState('');
    const [uploadedSlip, setUploadedSlip] = useState(null);
    const [uploadedSlipURL, setUploadedSlipURL] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage1, setCurrentPage1] = useState(1);
    const [currentPage2, setCurrentPage2] = useState(1);
    const itemsPerPage = 20;

      const [loading, setLoading] = useState(false);   
    

    useEffect(() => {
        
        if (activeTab === 'completed') {
            fetchCompletedSchemes();
        } else if (activeTab === 'packed') {
            fetchPackedOrders();
            fetchCurrentUser();
        }else if(activeTab === 'shipped'){
            fetchShippedOrders();
        }
    }, [activeTab]);


    const fetchCompletedSchemes = async () => {
        try {
            setLoading(true);
            const schemesRef = collection(db, 'schemes');
            
            // Query completed schemes ordered by completionDate DESC
            const completedSchemesQuery = query(
                schemesRef,
                where('status', '==', 'Completed'),
                orderBy('completedAt', 'desc')
            );
            
            const snapshot = await getDocs(completedSchemesQuery);
            const schemesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
            // Fetch user counts for each scheme
            const schemesWithUserCounts = await Promise.all(schemesData.map(async (scheme) => {
                const subscriptionsQuery = query(
                    collection(db, 'subscriptions'),
                    where('schemeId', '==', scheme.id)
                );
                const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
    
                const totalUsers = subscriptionsSnapshot.size;
                const completedUsers = subscriptionsSnapshot.docs.filter(doc => {
                    const data = doc.data();
                    return parseInt(data.paidMonths) === parseInt(data.totalMonths);
                }).length;
    
                return { ...scheme, totalUsers, completedUsers };
            }));
    
            setSchemes(schemesWithUserCounts);
            console.log(schemesWithUserCounts);
        } catch (err) {
            setError('Failed to fetch completed schemes');
            console.error(err);
        }finally{
            setLoading(false);
        }
    };

  
    const fetchPackedOrders = async () => {
        try {
            setLoading(true);
          const packedOrdersQuery = query(
            collection(db, 'order-processing'),
            where('PackingStatus', '==', 'Packed'),
            orderBy('createdAt', 'desc')
          );
          const packedOrdersSnapshot = await getDocs(packedOrdersQuery);
      
          const packedOrdersData = await Promise.all(
            packedOrdersSnapshot.docs.map(async (docSnap) => {
              const orderData = docSnap.data();
      
              // ❌ Skip if shippingStatus is 'Shipped'
              if (orderData.shippingStatus === 'Shipped') {
                return null;
              }
      
              let schemeName = 'N/A';
              let customerName = 'N/A';
              let customerPhone = 'N/A';
      
              // Fetch scheme name
              if (orderData.schemeId) {
                const schemeDocRef = doc(db, 'schemes', orderData.schemeId);
                const schemeDocSnap = await getDoc(schemeDocRef);
                if (schemeDocSnap.exists()) {
                  schemeName = schemeDocSnap.data().name || 'N/A';
                }
              }
      
              // Fetch customer details
              if (orderData.customerId) {
                const customerQuery = query(
                  collection(db, 'users'),
                  where('cusmid', '==', orderData.customerId)
                );
                const customerSnap = await getDocs(customerQuery);
                if (!customerSnap.empty) {
                  const customerDoc = customerSnap.docs[0];
                  const customerData = customerDoc.data();
                  customerName = customerData.name || 'N/A';
                  customerPhone = customerData.phone || 'N/A';
                }
              }
      
              return {
                id: docSnap.id,
                ...orderData,
                schemeName,
                customerName,
                customerPhone
              };
            })
          );
      
          // ❗ Filter out nulls (i.e., orders that were marked as 'Shipped')
          const filtered = packedOrdersData.filter((order) => order !== null);
      
          setPackedOrders(filtered);
          console.log(filtered);
        } catch (error) {
          console.error('Error fetching packed orders:', error);
        }finally{
            setLoading(false);
        }
      };
    const fetchShippedOrders = async () => {
        try {
            setLoading(true);
            const shippedOrdersQuery = query(
                collection(db, 'order-processing'),
                where('shippingStatus', '==', 'Shipped'),
                orderBy('createdAt', 'desc')
            );
            const shippedOrdersSnapshot = await getDocs(shippedOrdersQuery);
    
            const shippedOrdersData = await Promise.all(
                shippedOrdersSnapshot.docs.map(async (docSnap) => {
                    const orderData = docSnap.data();
                    let schemeName = 'N/A';
                    let customerName = 'N/A';
                    let customerPhone = 'N/A';
                   
    
                    // Fetch scheme name
                    if (orderData.schemeId) {
                        const schemeDocRef = doc(db, 'schemes', orderData.schemeId);
                        const schemeDocSnap = await getDoc(schemeDocRef);
                        if (schemeDocSnap.exists()) {
                            schemeName = schemeDocSnap.data().name || 'N/A';
                        }
                    }
                       
                    // Fetch customer details
                    if (orderData.customerId) {
                        console.log(orderData.customerId)
                        const customerQuery = query(
                            collection(db, 'users'),
                            where('cusmid', '==', orderData.customerId)
                        );
                        const customerSnap = await getDocs(customerQuery);
                        if (!customerSnap.empty) {
                        
                            const customerDoc = customerSnap.docs[0]; // Assuming cusmid is unique
                            const customerData = customerDoc.data();
                            console.log(customerData)
                            customerName = customerData.name || 'N/A';
                            customerPhone = customerData.phone || 'N/A';
                        
                        }
                    }
    
                    return {
                        id: docSnap.id,
                        ...orderData,
                        schemeName,
                        customerName,
                        customerPhone
                    };
                })
            );
    
            setShippedOrders(shippedOrdersData);
            console.log(shippedOrdersData)
        } catch (error) {
            console.error('Error fetching packed orders:', error);
        }finally{
            setLoading(false);
        }
    };
    const fetchCurrentUser = async () => {
        try {
            setLoading(true);
            const storedUser = JSON.parse(sessionStorage.getItem('user')); // Assuming the user object is stored as a JSON string
            if (storedUser && storedUser.uid) {
                const userRef = doc(db, 'crm_users', storedUser.uid);
                const userDoc = await getDoc(userRef);
                if (userDoc.exists()) {
                    setCurrentUser({ id: userDoc.id, ...userDoc.data() });
                } else {
                    console.log('No such user document!');
                }
            }
        } catch (error) {
            console.error('Error fetching current user:', error);
        }finally{
            setLoading(false);
        }
    };
    const filteredSchemes = schemes.filter(scheme => {
        const searchQueryLower = searchQuery1.toLowerCase();
        return (
            (scheme.name?.toLowerCase() || '').includes(searchQueryLower)||  // Search by Scheme Name
            (scheme.id?.toLowerCase() || '').includes(searchQueryLower)     // Search by Scheme ID
        );
    });
    // Filter packed orders based on the search query
    const filteredPackedOrders = packedOrders.filter(order => {
        const searchQueryLower = searchQuery2.toLowerCase();
        return (
            (order.schemeName?.toLowerCase() || '').includes(searchQueryLower) || // Search by Scheme Name
            (order.schemeId?.toLowerCase() || '').includes(searchQueryLower) ||  // Search by Scheme ID
            (order.id?.toLowerCase() || '').includes(searchQueryLower) ||        // Search by Order ID
            (order.customerId?.toLowerCase() || '').includes(searchQueryLower)  // Search by Customer ID
        );
    });
    const filteredShippedOrders = shippedOrders.filter(order => {
        const searchQueryLower = searchQuery3.toLowerCase();
        return (
            (order.schemeName?.toLowerCase() || '').includes(searchQueryLower) || // Search by Scheme Name
            (order.schemeId?.toLowerCase() || '').includes(searchQueryLower) ||  // Search by Scheme ID
            (order.id?.toLowerCase() || '').includes(searchQueryLower) ||        // Search by Order ID
            (order.customerId?.toLowerCase() || '').includes(searchQueryLower)  // Search by Customer ID
        );
    });
    const handleProcessOrder = (schemeId) => {
        navigate(`/processscheme/${schemeId}`);
    };

    const handleShowNotesModal = (order) => {
        setSelectedOrder(order);
        setOrderNotes(order.notes || '');
        setTrackingLink(order.trackingLink || '');
        setShowNotesModal(true);
        setUploadedSlipURL(order.slipURL || '');
    };

    const handleCloseNotesModal = () => {
        setShowNotesModal(false);
        setSelectedOrder(null);
        setOrderNotes('');
    };
    
       const handleNotesSubmit = async () => {
              try {
                
                  if (selectedOrder) {
                      const orderRef = doc(db, 'order-processing', selectedOrder.id);
                      let slipURL = selectedOrder.slipURL || '';
          
                      // Upload slip if a new file is selected
                      if (uploadedSlip) {
                          const storageRef = ref(storage, `orderSlips/${selectedOrder.id}_${uploadedSlip.name}`);
                          await uploadBytes(storageRef, uploadedSlip);
                          slipURL = await getDownloadURL(storageRef);
                      }
          
                      // Query to find subscription related to this order
                      const subscriptionQuery = query(
                          collection(db, 'subscriptions'),
                          where('userId', '==', selectedOrder.customerId)
                      );
          
                      const subscriptionSnapshot = await getDocs(subscriptionQuery);
                      const updatePromises = [];
          
                      // Update order-processing document
                      updatePromises.push(updateDoc(orderRef, {
                          notes: orderNotes,
                          trackingLink: trackingLink,
                          slipURL: slipURL,
                          packageProcessedBy: currentUser ? currentUser.username : 'Unknown',
                          deliveryStatus: "Processed"
                      }));
          
                      // Update subscription document(s)
                      if (!subscriptionSnapshot.empty) {
                          subscriptionSnapshot.docs.forEach(docSnap => {
                              const subscriptionRef = doc(db, 'subscriptions', docSnap.id);
                              updatePromises.push(updateDoc(subscriptionRef, {
                               
                                  packageProcessedBy: currentUser ? currentUser.username : 'Unknown',
                                  deliveryStatus: "Processed"
                              }));
                          });
                      } else {
                          console.warn("No subscription found for this customer.");
                      }
          
                      // Execute all updates
                      await Promise.all(updatePromises);
          
                      // Update local state
                      setPackedOrders(prevOrders =>
                          prevOrders.map(order =>
                              order.id === selectedOrder.id
                                  ? { ...order, notes: orderNotes, trackingLink: trackingLink, slipURL: slipURL }
                                  : order
                          )
                      );
          
                     
                      handleCloseNotesModal();
                      setToastMessage('Order and subscription processed successfully');
                      setToastVariant('success');
                      setShowToast(true);
                  }
              } catch (error) {
                  console.error('Error updating order and subscription notes:', error);
                  setToastMessage('Error updating order and subscription. Please try again.');
                  setToastVariant('danger');
                  setShowToast(true);
              }
          };
        const handlePrintSlip = async (order) => {
            try {
                const storageRef = ref(storage, `deliverySlips/${order.customerId}_${order.schemeId}.pdf`);
                const deliverySlipURL = await getDownloadURL(storageRef);
                window.open(deliverySlipURL, '_blank');
            } catch (error) {
                console.error('Error fetching delivery slip:', error);
                setToastMessage('Error fetching delivery slip. Please try again.');
                setToastVariant('danger');
                setShowToast(true);
            }
        };
        const handleShipped = async (order) => {
            try {
              const orderRef = doc(db, "order-processing", order.id);
              await updateDoc(orderRef, {
                shippingStatus: "Shipped"
              });
              setToastMessage('Package moved to shipped');
              setToastVariant('success');
              setShowToast(true);
              fetchPackedOrders();
              fetchShippedOrders();
             

            } catch (error) {
              console.error("Error updating shipping status:", error);
              setToastMessage('Failed to update shipping status.');
              setToastVariant('danger');
              setShowToast(true);
            }
          };
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = filteredSchemes.slice(indexOfFirstItem, indexOfLastItem);
    
        const paginate = (pageNumber) => setCurrentPage(pageNumber);

        const indexOfLastItem1 = currentPage1 * itemsPerPage;
        const indexOfFirstItem1 = indexOfLastItem1 - itemsPerPage;
        const currentItems1 = filteredPackedOrders.slice(indexOfFirstItem1, indexOfLastItem1);

        const paginate1= (pageNumber1) => setCurrentPage1(pageNumber1);

        const indexOfLastItem2 = currentPage1 * itemsPerPage;
        const indexOfFirstItem2 = indexOfLastItem1 - itemsPerPage;
        const currentItems2 = filteredShippedOrders.slice(indexOfFirstItem2, indexOfLastItem2);

        const paginate2= (pageNumber2) => setCurrentPage2(pageNumber2);

        if (loading) {
            // Render loading screen
            
            return (
              <div className="loading-screen">
                
              <Loading/>
              </div>
            );
          }
    return (
        <Container fluid className='inventory-page'>
              <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
            <br />
            <h1>Billing & Packing</h1>
            {error && <Alert variant="danger">{error}</Alert>}
            <Tabs
                id="delivery-tabs"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
            >
                <Tab eventKey="completed" title="Completed Schemes">
                    <Form className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Search by Scheme Name or Scheme ID"
                        value={searchQuery1}
                        onChange={(e) => setSearchQuery1(e.target.value)}
                    />
                    </Form>
                    <Table striped bordered hover>
                        <thead>
                            <tr className='scheme-det-font-head'>
                                <th>Id</th>
                                <th>Scheme Name</th>
                                <th>Total Users</th>
                                <th>Completed Users</th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((scheme) => (
                                <tr key={scheme.id} className='scheme-det-font'>
                                    <td>{scheme.id}</td>
                                    <td>
                                    <Link to={`/processscheme/${scheme.id}`} style={{ textDecoration: 'none', color: 'blue' }}>
                                        {scheme.name}
                                    </Link> 
                                    </td>
                                    <td>{scheme.totalUsers}</td>
                                    <td>{scheme.completedUsers}</td>
                                   
                                    
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Pagination>
                        {Array.from({ length: Math.ceil(filteredSchemes.length / itemsPerPage) }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => paginate (index + 1)}                        
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </Tab>
                <Tab eventKey="packed" title="Packed packages">
                    <Form className="mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Search by Scheme Name, Scheme ID, Order ID, or Customer ID"
                            value={searchQuery2}
                            onChange={(e) => setSearchQuery2(e.target.value)}
                        />
                    </Form>
                    <Table striped bordered hover style={{overflow:'scroll'}}>
                        <thead>
                            <tr className='scheme-det-font-head'>
                                <th>Package ID</th>
                                <th>Scheme ID</th>
                                <th>Scheme name</th>
                                <th>Customer ID</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Packed Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems1.map((order) => (
                                <tr key={order.id} className='scheme-det-font'>
                                    <td>{order.id}</td>
                                    <td>{order.schemeId}</td>
                                    <td>{order.schemeName}</td>
                                    <td>{order.customerId}</td>
                                    <td>{order.customerName}</td>
                                    <td>{order.customerPhone}</td>
                                    <td>{new Date(order.createdAt.seconds * 1000).toLocaleString()}</td>
                                    <td>
                                        <Button variant="outline-primary" className='btn btn m-1' onClick={() => handleShowNotesModal(order)}>
                                            <FaNoteSticky/> Order Notes
                                        </Button>
                                        <Button variant="outline-secondary" className='btn btn m-1' onClick={() => handlePrintSlip(order)}>
                                            <FaPrint/> Print Slip
                                        </Button>
                                        <Button
                                            variant="outline-success"
                                            className="btn btn m-1"
                                            onClick={() => {
                                                const confirmShip = window.confirm(`Are you sure you want to mark Order ${order.id} as Shipped?`);
                                                if (confirmShip) {
                                                handleShipped(order);
                                                }
                                            }}
                                            >
                                            <FaTruck /> Mark as shipped
                                            </Button>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Pagination>
                        {Array.from({ length: Math.ceil(filteredPackedOrders.length / itemsPerPage) }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage1}
                                onClick={() => paginate1 (index + 1)}                        
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </Tab>
                <Tab eventKey="shipped" title="Shipped Orders">
                    <Form className="mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Search by Scheme Name, Scheme ID, Order ID, or Customer ID"
                            value={searchQuery3}
                            onChange={(e) => setSearchQuery3(e.target.value)}
                        />
                    </Form>
                    <Table striped bordered hover style={{overflow:'scroll'}}>
                        <thead>
                            <tr className='scheme-det-font-head'>
                                <th>Package ID</th>
                                <th>Scheme ID</th>
                                <th>Scheme name</th>
                                <th>Customer ID</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Packed Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems2.map((shipped) => (
                                <tr key={shipped.id} className='scheme-det-font'>
                                    <td>{shipped.id}</td>
                                    <td>{shipped.schemeId}</td>
                                    <td>{shipped.schemeName}</td>
                                    <td>{shipped.customerId}</td>
                                    <td>{shipped.customerName}</td>
                                    <td>{shipped.customerPhone}</td>
                                    <td>{new Date(shipped.createdAt.seconds * 1000).toLocaleString()}</td>
                                    <td>
                                        <Button variant="outline-primary" className='btn btn m-1' onClick={() => handleShowNotesModal(shipped)}>
                                            <FaNoteSticky/> Order Notes
                                        </Button>
                                        <Button variant="outline-secondary" className='btn btn m-1' onClick={() => handlePrintSlip(shipped)}>
                                            <FaPrint/> Print Slip
                                        </Button>
                                      
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Pagination>
                        {Array.from({ length: Math.ceil(filteredShippedOrders.length / itemsPerPage) }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage1}
                                onClick={() => paginate2 (index + 1)}                        
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </Tab>
            </Tabs>
                <Modal show={showNotesModal}  onHide={handleCloseNotesModal}>
                          <Modal.Header closeButton>
                              <Modal.Title>Order Notes</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                              <Form.Group className="mb-3">
                                  <Form.Label>Notes</Form.Label>
                                  <Form.Control
                                      as="textarea"
                                      rows={3}
                                      value={orderNotes}
                                      onChange={(e) => setOrderNotes(e.target.value)}
                                  />
                              </Form.Group>
                              <Form.Group className="mb-3">
                                  <Form.Label>Tracking Link</Form.Label>
                                  <Form.Control
                                      type="text"
                                      value={trackingLink}
                                      onChange={(e) => setTrackingLink(e.target.value)}
                                  />
                              </Form.Group>
                              <Form.Group className="mb-3">
                                  <Form.Label>Upload Slip</Form.Label>
                                  <Form.Control
                                      type="file"
                                      onChange={(e) => {
                                          setUploadedSlip(e.target.files[0]);
                                          setUploadedSlipURL(URL.createObjectURL(e.target.files[0]));
                                      }}
                                  />
                              </Form.Group>
                              {uploadedSlipURL && (
                                  <div className="mb-3">
                                      <Form.Label>Uploaded Slip Preview</Form.Label>
                                      <img src={uploadedSlipURL} alt="Uploaded Slip" style={{ width: '100%', height: 'auto' }} />
                                  </div>
                              )}
                          </Modal.Body>
                          <Modal.Footer>
                              <Button variant="outline-secondary" className='btn btn' onClick={handleCloseNotesModal}>
                                  Close
                              </Button>
                              <Button variant="outline-success" className='btn btn' onClick={handleNotesSubmit}>
                                  Submit
                              </Button>
                          </Modal.Footer>
                      </Modal>
        </Container>
    );
};

export default Delivery;